import {
  ICountry, IUser,
} from './authInterface';
import { FacilityFormStoreModel } from './facilityFormInterface';
import { RequestStatus } from 'mobx-store';

export interface IFacilityStore {
  facilitiesList: any[];
  selectedFacility: any;
  branchFacilitiesStatistics: BranchFacilitiesStatistics;
  areaFacilitiesStatistics: AreaFacilitiesStatistics;
  facilityStatistics: FacilityStatistics;
  facilityQR: string;
  loading: boolean;
  getFacilitiesRequestStatus: RequestStatus;
  getFacilities(availableCountries: ICountry[], facilityType:string,  searchQuery?: string, langCode?: string): Promise<any>;
  getRatingFacilitiesReport(langCode?: string): Promise<void>;
  getFacilityById(facilityId: number, langCode?: string): Promise<any>;
  getFacilityQR(facilityId: number, langCode?: string): Promise<void>;
  updateFacility(
    updatedFacility : ICreateFacility, facilityId : number, initImagesGallery: MediaFile[],
    initVideosGallery: MediaFile[], initImages360Gallery: MediaFile[], langCode: string,
  ): Promise<any>;
  createFacility(newFacility: ICreateFacility, langCode?: string): Promise<any>;
  updateFacilityStatus(facilityId: number, updatedFacilityStatus: boolean): Promise<any>;
  getFacilitiesBrnachRatingStatistics(branchId: number, from?: string | number , to?: string | number ): Promise<any>;
  getFacilitiesAreaRatingStatistics(branchId: number, areaId: number , from?: string | number , to?: string | number ): Promise<any>;
  getFacilityRatingStatistics(facilityId: number, from?: string | number , to?: string | number): Promise<any>;
  exportFacilitiesBranchRatingStatistics(branchId: number, branchTitle: string): Promise <any>;
  exportFacilitiesAreaRatingStatistics(branchId: number, areaId: number): Promise <any>;
}

export interface Image {
  imageUrl: string;
  key: number;
  type?: string;
}

export interface FilteredGallery {
  newFilesLinks: string[];
  deletedIds: number[],
}

export enum MediaTypes {
  Image = 'image',
  Image360 = 'image360',
  Video = 'video',
}

export interface MediaFile {
  mediaId: number;
  mediaType: MediaTypes;
  url: string;
}
export interface IFacility {
  facilityId: number;
  isActive: boolean;
  imageUrl: string;
  branch: {
    branchId: number;
    title: string;
  };
  facilityCategory:{
    facilityCategoryId: number;
    title: string;
  };
  facilityGroup:{
    FacilityGroupId: number;
    title: string;
  };
  name: string;
  facilityArea?: {
    facilityAreaId: number;
    title: string;
  },
  questionsFormId: number;
  media?: MediaFile[],
}
export interface ICreateFacility {
  isActive: boolean;
  imageUrl?: string | File[];
  branchId: number;
  facilityType: string;
  facilityCategory: number;
  facilityGroup: number;
  name: string;
  availableCountries: string[];
  facilityArea: number;
  facilityForm: number;
  images?: string [] | File[];
  videos?: string []| File[];
  images360?: string []| File[];
}

export interface IRatingFacilitiesReportsOptions {
  branchId?: number;
  categoryId?: number;
  areaId?: number;
  rating?: number;
  availableCountries: ICountry[];
  query?: string;
}

export interface IFacilityResponsesListOptions {
  from?: Date;
  to?: Date;
  availableCountries: ICountry[];
  rating?: number;
}

export interface FacilityResponse {
  membershipId: string;
  userId: number;
  value: number;
  name: string;
  userFormResponseId: number;
}

export interface IUserFormResponse {
  userFormResponseId: number;
  user: IUser;
  questionsForm: FacilityFormStoreModel;
  numericalResponses: IQuestionResponse[];
  textResponses: IQuestionResponse[];
  multipleChoiceResponses: IQuestionResponse[];
}

export interface BranchFacilitiesStatistics {
  points: number [];
  labels: string[];
}

interface FacilitiesStatistics {
  points: number [];
  labels: string[];
}

export interface AreaFacilitiesStatistics extends FacilitiesStatistics { }

export interface FacilityStatistics extends FacilitiesStatistics {}

interface IQuestionResponse {
  value: string | number;
  questionTitle: string;
  choice?: string;
}
